import { combineReducers } from '@reduxjs/toolkit';
import createTableHeaderReducer from './create/createSlice';
import tableHeaderListReducer from './list/listSlice';

const technicalInfoSlice = combineReducers({
    create: createTableHeaderReducer,
    list: tableHeaderListReducer,
});

export default technicalInfoSlice;
